import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid2 } from '@mui/material';
import { CreateXMLTopologyAction } from '../actions/DataManagementActions';
import { enqueueSnackbar } from 'actions';
import ConfirmDialog from './ConfirmDialog';

const CreateXMLTopologyFromFTPForm = () => {
	const userId = useSelector(state => state.session.user.id);
	const dispatch = useDispatch();

	const [confirmOpen, setConfirmOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const handleConfirm = async () => {
		const formData = new FormData();
		formData.append('UserId', userId);

		try {
			setIsLoading(true);
			const data = await CreateXMLTopologyAction(formData);
			dispatch(enqueueSnackbar({ message: data.message, options: { variant: 'success' } }));
		} catch (error) {
			dispatch(enqueueSnackbar({ message: `The process has not started because an error occured. ${error}`, options: { variant: 'error' } }));
		} finally {
			setIsLoading(false);
			setConfirmOpen(false);
		}
	};

	return (
		<Grid2 container spacing={2}>
			<Grid2 item size={12}>
				<Button
					variant="contained"
					color="primary"
					fullWidth
					onClick={() => setConfirmOpen(true)}
					disabled={isLoading}
				>
					Update Data
				</Button>
			</Grid2>

			<ConfirmDialog
				open={confirmOpen}
				title="Update Data"
				message="Are you sure you want to update all data?"
				onConfirm={handleConfirm}
				onCancel={() => setConfirmOpen(false)}
				isLoading={isLoading}
			/>
		</Grid2>
	);
};

export default CreateXMLTopologyFromFTPForm;
